import React from 'react';

const SquareInformationIcon = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" style={props.style} width="24" height="24" viewBox="0 0 24 24">
      <path
        fillRule="nonzero"
        d="M21.429 0H2.57A2.571 2.571 0 0 0 0 2.571V21.43A2.571 2.571 0 0 0 2.571 24H21.43A2.571 2.571 0 0 0 24 21.429V2.57A2.571 2.571 0 0 0 21.429 0zM12 4.607a2.25 2.25 0 1 1 0 4.5 2.25 2.25 0 0 1 0-4.5zm3 13.607a.643.643 0 0 1-.643.643H9.643A.643.643 0 0 1 9 18.214V16.93c0-.355.288-.643.643-.643h.643v-3.429h-.643A.643.643 0 0 1 9 12.214V10.93c0-.355.288-.643.643-.643h3.428c.355 0 .643.288.643.643v5.357h.643c.355 0 .643.288.643.643v1.285z"
      />
    </svg>
  );
};

export default SquareInformationIcon;
